import { apiClient } from '@/lib/api-client';
import type {
  ApiResponse,
  ProvisionedMeter,
  CreateProvisionedMeterRequest,
  UpdateProvisionedMeterRequest,
  PaginatedResponse,
} from '@/types/api';

export interface GetProvisionedMetersParams {
  search?: string;
  page?: number;
  perPage?: number;
}

export async function getProvisionedMeters(
  params: GetProvisionedMetersParams = {}
): Promise<PaginatedResponse<ProvisionedMeter>> {
  const response = await apiClient.get<PaginatedResponse<ProvisionedMeter>>(
    '/provisioned-meters',
    { params }
  );
  return response.data;
}

export async function lookupProvisionedMeter(
  serialNumber: string
): Promise<ApiResponse<ProvisionedMeter>> {
  const response = await apiClient.get<ApiResponse<ProvisionedMeter>>(
    `/provisioned-meters/by-serial/${encodeURIComponent(serialNumber)}`
  );
  return response.data;
}

export async function createProvisionedMeter(
  data: CreateProvisionedMeterRequest
): Promise<ApiResponse<ProvisionedMeter>> {
  const response = await apiClient.post<ApiResponse<ProvisionedMeter>>(
    '/provisioned-meters',
    data
  );
  return response.data;
}

export async function updateProvisionedMeter(
  id: string,
  data: UpdateProvisionedMeterRequest
): Promise<ApiResponse<null>> {
  const response = await apiClient.put<ApiResponse<null>>(
    `/provisioned-meters/${id}`,
    data
  );
  return response.data;
}

export async function deleteProvisionedMeter(
  id: string
): Promise<ApiResponse<null>> {
  const response = await apiClient.delete<ApiResponse<null>>(
    `/provisioned-meters/${id}`
  );
  return response.data;
}
